import UIDs from "../../../../UIDs";

const uid = UIDs.screens.account.ssoredirect;

const ActionTypes = {
    // Initialize
    INITIALIZE_ASYNC: `${uid}.initializeAsync`,
    INITIALIZE_SUCCESS: `${uid}.initializeSuccess`,
    INITIALIZE_FAILURE: `${uid}.initializeFailure`,
    
    // Add screen state action type
    UPDATE_SCREEN_STATE: `${uid}.updateScreenState`,

    // SSO Login
    SSO_LOGIN_FETCH_TOKEN_ASYNC: `${uid}.ssoLoginFetchingTokenAsync`,
    SSO_LOGIN_SUCCESS: `${uid}.ssoLoginSuccess`,
    SSO_LOGIN_FAILURE: `${uid}.ssoLoginFailure`,
};

export { ActionTypes };
